<div class="fw pb-1 mat-text-white mat-grey-500" fxLayout="column" fxLayoutAlign="start center">
    <h2 fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <mat-icon>hourglass_empty</mat-icon>
        <b>{{ call.remoteNumber }}</b>
        <mat-icon *ngIf="call.answerTime">access_time</mat-icon>
        <timer-since *ngIf="call.answerTime" [since]="call.answerTime"></timer-since>
    </h2>
    <h4 class="mt-0 mb-0" *ngIf="uimodeCallCenter() && queueName">
        <b class="text-uppercase">{{ 'call_active.queue'|translate }}:</b> {{ queueName }}
    </h4>
    <h4 class="mt-0 mb-0" *ngIf="uimodeCallCenter() && groupName">
        <b class="text-uppercase">{{ 'call_active.group'|translate }}:</b> {{ groupName }}
    </h4>
</div>
